import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function MetaAppSecurityEditor({ connector, onSaved }) {
  const [appId, setAppId] = useState(connector.extra_config?.app_id || "");
  const [secret, setSecret] = useState("");
  const [saving, setSaving] = useState(false);
  const save = async () => {
    if (!/^\d{5,30}$/.test(appId.trim())) return toast.error("Enter the existing numeric Meta App ID");
    if (!secret.trim() && !connector.app_secret_configured) return toast.error("Enter the existing Meta App Secret");
    setSaving(true);
    try {
      const { data } = await api.put(`/messaging-connectors/${connector.id}`, {
        meta_app_id: appId.trim(), meta_app_secret: secret.trim(),
      });
      if (!data.app_identity_verified) throw new Error("verification_unconfirmed");
      toast.success("Existing Meta app verified; secret saved privately");
      onSaved?.();
    } catch {
      toast.error("Could not verify and save the Meta app. Check the existing App ID, secret and Meta permissions.");
    } finally {
      setSecret(""); setSaving(false);
    }
  };
  return <div className="mt-3 border rounded p-3" data-testid={`meta-app-security-${connector.id}`}>
    <div className="text-xs font-semibold">Webhook signature verification</div>
    <p className="text-xs text-slate-600">Use the existing Meta app. This does not change your WhatsApp access token or create a connector.</p>
    <p className="text-xs" data-testid="meta-app-state">{connector.app_identity_verified ? "App identity verified · Secret configured" : "App identity verification required"}</p>
    <label className="block text-xs mt-2">Meta App ID
      <input data-testid="meta-app-id" inputMode="numeric" value={appId} disabled={saving}
        onChange={e => setAppId(e.target.value)} className="block border rounded px-2 py-1" />
    </label>
    <label className="block text-xs mt-2">Existing Meta App Secret
      <input data-testid="meta-app-secret" type="password" autoComplete="new-password" value={secret} disabled={saving}
        onChange={e => setSecret(e.target.value)} placeholder={connector.app_secret_configured ? "Leave blank to keep saved secret" : "Enter existing App Secret"}
        className="block border rounded px-2 py-1" />
    </label>
    <button type="button" data-testid="meta-app-save" disabled={saving} onClick={save}
      className="mt-2 border rounded px-3 py-1 text-xs">{saving ? "Verifying…" : "Verify and save existing app"}</button>
  </div>;
}
